<!-- Modern Glassmorphic Preloader -->
<div *ngIf="isLoading" id="preloader-active"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-md">
    <div
        class="bg-white/95 rounded-3xl p-8 max-w-sm w-full mx-4 shadow-2xl border border-white/50 flex flex-col items-center text-center space-y-4 animate-fade-in">
        <div class="relative w-20 h-20 flex items-center justify-center">
            <div class="absolute inset-0 bg-emerald-400/20 rounded-full blur-xl animate-pulse"></div>
            <img src="/assets/visidea/logo-visidea3.svg" alt="Visidea Studio"
                class="w-16 h-16 object-contain relative z-10 drop-shadow-md animate-bounce">
        </div>
        <div>
            <h4 class="text-base font-extrabold text-[#102B51] tracking-tight">Menyiapkan Foto Anda</h4>
            <p class="text-xs text-gray-500 mt-1 font-medium">Mohon tunggu sebentar...</p>
        </div>
        <!-- Shimmer Progress Bar -->
        <div class="w-full h-2 rounded-full overflow-hidden bg-gray-100 relative">
            <div class="w-full h-full skeleton-shimmer"></div>
        </div>
    </div>
</div>

<!-- Main Container -->
<div class="flex justify-center min-h-screen bg-cover bg-center bg-no-repeat"
    [style.background-image]="'url(' + bgImage + ')'">
    <div class="w-full max-w-[500px] min-h-screen bg-cover bg-center bg-no-repeat"
        [style.background-image]="'url(' + bgImage + ')'">

        <!-- Logo Section -->
        <div class="container-fluid text-center relative">
            <div class="flex flex-col justify-center px-3">
                <div class="w-full">
                    <div class="mx-auto text-center pt-5">
                        <!-- Logo -->
                        <img class="w-[120px] pt-5 mx-auto"
                            src="https://photobooth.awh.co.id/assets/photobooth/images/logo/logo_visidea_portrait_color.png"
                            alt="Visidea Logo">

                        <!-- Photo Gallery Section -->
                        <div *ngIf="!photoExpired" class="w-full text-center pt-3 mb-5">
                            <!-- Main Photo Slider -->
                            <div class="mb-3">
                                <!-- Horizontal Scroll Container -->
                                <div class="scroll-container" #photoScrollContainer>
                                    <!-- Merge Photos -->
                                    <div *ngFor="let photo of linkPhotoCetak; let i = index" class="scroll-item">
                                        <div class="relative w-[300px] h-auto rounded-2xl overflow-hidden bg-gray-100">
                                            <!-- Loading Progress -->
                                            <div *ngIf="photo.loading"
                                                class="absolute inset-0 bg-white/85 flex flex-col justify-center items-center z-10">
                                                <div class="w-[70%] h-2 bg-gradient-to-r from-[#F498AE] to-[#da365c] rounded-full origin-left transition-transform duration-300"
                                                    [style.transform]="'scaleX(' + photo.progress / 100 + ')'">
                                                </div>
                                                <span class="mt-2 text-sm font-semibold text-gray-800">{{ photo.progress
                                                    }}%</span>
                                            </div>

                                            <!-- Photo Image -->
                                            <img [src]="photo.thumbnail" [attr.data-photo-original]="photo.original"
                                                [attr.data-photo-url]="photo.thumbnail"
                                                [attr.data-photo-name]="cleanName + '_merge_photo_' + (i + 1)"
                                                class="w-full h-full object-cover cursor-pointer transition-opacity duration-400"
                                                [class.opacity-0]="photo.loading" [class.opacity-100]="!photo.loading"
                                                (click)="downloadPhoto(photo.original, cleanName + '_merge_photo_' + (i + 1) + '.jpg')"
                                                alt="Photo">
                                        </div>
                                    </div>

                                    <!-- Single Photos -->
                                    <div *ngFor="let photo of linkPhotoCetakSatuan; let i = index" class="scroll-item">
                                        <div class="relative w-[300px] h-auto rounded-2xl overflow-hidden bg-gray-100">
                                            <!-- Loading Progress -->
                                            <div *ngIf="photo.loading"
                                                class="absolute inset-0 bg-white/85 flex flex-col justify-center items-center z-10">
                                                <div class="w-[70%] h-2 bg-gradient-to-r from-[#F498AE] to-[#da365c] rounded-full origin-left transition-transform duration-300"
                                                    [style.transform]="'scaleX(' + photo.progress / 100 + ')'">
                                                </div>
                                                <span class="mt-2 text-sm font-semibold text-gray-800">{{ photo.progress
                                                    }}%</span>
                                            </div>

                                            <!-- Photo Image -->
                                            <img [src]="photo.thumbnail" [attr.data-photo-original]="photo.original"
                                                [attr.data-photo-url]="photo.thumbnail"
                                                [attr.data-photo-name]="cleanName + '_photo_' + (i + 1)"
                                                class="w-full h-full object-cover cursor-pointer transition-opacity duration-400"
                                                [class.opacity-0]="photo.loading" [class.opacity-100]="!photo.loading"
                                                (click)="downloadPhoto(photo.original, cleanName + '_photo_' + (i + 1) + '.jpg')"
                                                alt="Photo">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- GIF Gallery -->
                            <div *ngIf="linkPhotoGif && linkPhotoGif.length > 0" class="w-full text-center mb-5">
                                <h2 class="text-white text-2xl mb-3 font-bold">PHOTO GIF</h2>
                                <div class="flex flex-col items-center gap-5">
                                    <div *ngFor="let gif of linkPhotoGif; let i = index">
                                        <img [src]="gif" class="w-[300px] object-cover rounded-xl cursor-pointer"
                                            alt="GIF">
                                    </div>
                                </div>
                            </div>

                            <!-- Video Gallery -->
                            <div *ngIf="linkPhotoboothVideo && linkPhotoboothVideo.length > 0"
                                class="w-full text-center mb-5">
                                <h2 class="text-white text-2xl mb-3 font-bold">GIF</h2>
                                <div class="flex flex-col items-center gap-5">
                                    <div *ngFor="let video of linkPhotoboothVideo; let i = index"
                                        class="flex flex-col items-center">
                                        <video [src]="video" class="w-[300px] object-cover rounded-xl" autoplay loop
                                            muted playsinline controls></video>
                                        <button
                                            (click)="downloadVideo(video, 'GIF_' + nama + '_' + (i + 1) + '.mp4', $event)"
                                            class="mt-6 px-4 py-2 bg-[#F498AE] border-2 border-white text-white rounded-lg hover:bg-[#F498AE] transition">
                                            Download GIF
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Download All Button -->
                            <div *ngIf="linkPhotoCetakSatuan.length > 0" class="w-full text-center mb-5 mt-3">
                                <div class="container">
                                    <div class="flex justify-center items-center">
                                        <button (click)="downloadAllImages()"
                                            class="px-2 py-2 mt-2 bg-[#F498AE] text-white border-2 border-white rounded-full hover:opacity-90 transition">
                                            <img src="https://photobooth.awh.co.id/assets/photobooth/images/download.png"
                                                class="w-[70%] mx-auto" alt="Download">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Photo Expired Message -->
                        <div *ngIf="photoExpired" class="text-center my-1 py-5">
                            <h2 class="text-white text-2xl mb-3">Foto atau File Asli kamu sudah terhapus otomatis
                                setelah 7 hari.</h2>
                            <p class="text-white">Silahkan Berfoto Kembali Di Awh Photobooth</p>
                        </div>
                    </div>
                </div>

                <!-- QR Code Section -->
                <div *ngIf="!photoExpired" class="w-full lg:w-10/12 xl:w-10/12 mb-5 mx-auto text-center">
                    <div class="mt-3 mx-auto">
                        <div class="flex justify-center">
                            <div class="w-full">
                                <div class="text-center">
                                    <!-- Debug Info -->
                                    <!-- <div class="text-white text-xs mb-2">
                                        Debug: qrCodeData = "{{ qrCodeData }}" ({{ qrCodeData ? 'HAS DATA' : 'EMPTY' }})
                                    </div> -->

                                    <!-- QR Code Image - Direct binding -->
                                    <div *ngIf="qrCodeData" class="inline-block cursor-pointer relative"
                                        (click)="openQRModal()">
                                        <img [src]="getQRCodeUrl()" alt="QR Code"
                                            class="w-48 h-48 mx-auto rounded-lg shadow-lg bg-white p-2"
                                            (error)="onQRImageError($event)" (load)="onQRImageLoad()">

                                        <!-- Logo Overlay -->
                                        <div
                                            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white">
                                            <img src="https://photobooth.awh.co.id/assets/photobooth/images/logo/logo_visidea_portrait_color.png"
                                                alt="Visidea Logo" class="w-14 h-7 object-contain">
                                        </div>
                                    </div>
                                    <div *ngIf="!qrCodeData" class="text-white text-sm">
                                        Loading QR Code...
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Decorative Images (Selkachi) -->
                    <img *ngIf="isSelkachi" src="assets/photobooth/images/left_men.png"
                        class="w-[25%] md:w-[20%] absolute left-[-15px] top-[20%] md:top-0" alt="Left">
                    <img *ngIf="isSelkachi" src="assets/photobooth/images/right_women.png"
                        class="w-[25%] md:w-[20%] absolute right-[-15px] top-[20%] md:top-0" alt="Right">
                    <img *ngIf="isSelkachi" src="assets/photobooth/images/scan.png"
                        class="w-[50%] md:w-[20%] mb-5 mx-auto" alt="Scan">

                    <!-- Guest Name -->
                    <h2 class="text-base font-medium mt-8 text-white">{{ nama }}</h2>

                    <!-- Instructions -->
                    <h2 *ngIf="isSelkachi" class="text-sm mt-8 font-medium text-white">
                        Mau foto kece ini dicetak lagi? Cukup scan QR di atas yaa<br>
                    </h2>
                    <h2 *ngIf="isSelkachi" class="text-base mt-6 font-extrabold text-white">
                        #FotoAsikBarengSelka dan abadikan momen kamu dengan gaya <br> Korea yang super fun! <br>
                        #PhotoboothBandung #SelkaChiMood #FrameGemesSelka
                    </h2>

                    <h2 *ngIf="!isSelkachi && linkPhotoCetakSatuan.length > 0"
                        class="text-sm mt-8 font-medium text-white">
                        Mau foto kece ini dicetak lagi? Cukup scan QR di atas yaa<br>
                    </h2>
                </div>

                <!-- FAQ Section -->
                <div *ngIf="!photoExpired" class="w-full flex justify-center mb-[70px]">
                    <div class="w-full max-w-[520px] font-sans">
                        <!-- Title -->
                        <div class="text-center mb-3">
                            <h5 class="mb-1 text-white font-semibold">Frequently Asked Questions</h5>
                            <small class="text-white/80">Pertanyaan yang sering diajukan</small>
                        </div>

                        <!-- Accordion Group -->
                        <div class="bg-white rounded-2xl shadow-lg overflow-hidden">
                            <!-- FAQ Item 1 -->
                            <div class="border-b border-gray-200 last:border-b-0" [class.active]="activeFaq === 1">
                                <button (click)="toggleFaq(1)"
                                    class="w-full bg-transparent border-none p-4 text-sm font-semibold flex justify-between items-center text-left cursor-pointer hover:bg-gray-50 transition">
                                    <span>Bagaimana cara menyimpan foto?</span>
                                    <span class="text-xl transition-transform duration-300"
                                        [class.rotate-45]="activeFaq === 1">+</span>
                                </button>
                                <div class="overflow-hidden transition-all duration-350"
                                    [class.max-h-0]="activeFaq !== 1" [class.max-h-[180px]]="activeFaq === 1"
                                    [class.p-0]="activeFaq !== 1" [class.px-4]="activeFaq === 1"
                                    [class.pb-4]="activeFaq === 1">
                                    <p class="text-sm text-gray-600 leading-relaxed">
                                        Ketuk foto untuk membuka preview. Tekan tombol download atau pada iOS tekan dan
                                        tahan foto lalu pilih <b>Save Image</b>.
                                    </p>
                                </div>
                            </div>

                            <!-- FAQ Item 2 -->
                            <div class="border-b border-gray-200 last:border-b-0" [class.active]="activeFaq === 2">
                                <button (click)="toggleFaq(2)"
                                    class="w-full bg-transparent border-none p-4 text-sm font-semibold flex justify-between items-center text-left cursor-pointer hover:bg-gray-50 transition">
                                    <span>Kenapa foto tidak langsung terdownload di iOS?</span>
                                    <span class="text-xl transition-transform duration-300"
                                        [class.rotate-45]="activeFaq === 2">+</span>
                                </button>
                                <div class="overflow-hidden transition-all duration-350"
                                    [class.max-h-0]="activeFaq !== 2" [class.max-h-[180px]]="activeFaq === 2"
                                    [class.p-0]="activeFaq !== 2" [class.px-4]="activeFaq === 2"
                                    [class.pb-4]="activeFaq === 2">
                                    <p class="text-sm text-gray-600 leading-relaxed">
                                        iOS memiliki batasan download otomatis. Foto akan terbuka di tab baru dan bisa
                                        disimpan manual ke galeri.
                                    </p>
                                </div>
                            </div>

                            <!-- FAQ Item 3 -->
                            <div class="border-b border-gray-200 last:border-b-0" [class.active]="activeFaq === 3">
                                <button (click)="toggleFaq(3)"
                                    class="w-full bg-transparent border-none p-4 text-sm font-semibold flex justify-between items-center text-left cursor-pointer hover:bg-gray-50 transition">
                                    <span>Berapa lama foto tersimpan di sistem?</span>
                                    <span class="text-xl transition-transform duration-300"
                                        [class.rotate-45]="activeFaq === 3">+</span>
                                </button>
                                <div class="overflow-hidden transition-all duration-350"
                                    [class.max-h-0]="activeFaq !== 3" [class.max-h-[180px]]="activeFaq === 3"
                                    [class.p-0]="activeFaq !== 3" [class.px-4]="activeFaq === 3"
                                    [class.pb-4]="activeFaq === 3">
                                    <p class="text-sm text-gray-600 leading-relaxed">
                                        Foto disimpan selama <b>7 hari</b> di sistem. Setelah itu, foto akan <b>dihapus
                                            secara otomatis</b>.
                                        Pastikan kamu segera mengunduh semua foto agar tidak hilang.
                                    </p>
                                </div>
                            </div>

                            <!-- FAQ Item 4 -->
                            <div class="border-b border-gray-200 last:border-b-0" [class.active]="activeFaq === 4">
                                <button (click)="toggleFaq(4)"
                                    class="w-full bg-transparent border-none p-4 text-sm font-semibold flex justify-between items-center text-left cursor-pointer hover:bg-gray-50 transition">
                                    <span>Cara Extract ZIP Folder Di iOS</span>
                                    <span class="text-xl transition-transform duration-300"
                                        [class.rotate-45]="activeFaq === 4">+</span>
                                </button>
                                <div class="overflow-hidden transition-all duration-350"
                                    [class.max-h-0]="activeFaq !== 4" [class.max-h-[180px]]="activeFaq === 4"
                                    [class.p-0]="activeFaq !== 4" [class.px-4]="activeFaq === 4"
                                    [class.pb-4]="activeFaq === 4">
                                    <p class="text-sm text-gray-600 leading-relaxed">
                                        Buka aplikasi <b>Files</b> di iPhone, lalu masuk ke folder tempat file ZIP
                                        tersimpan.
                                        Ketuk file ZIP tersebut sekali, maka iOS akan <b>mengekstrak otomatis</b> ke
                                        dalam folder baru.
                                        Jika file berasal dari browser, biasanya tersimpan di folder <b>Downloads</b>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- QR Code Modal -->
<div *ngIf="showQRModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    (click)="closeQRModal()">
    <div class="bg-white rounded-lg max-w-md w-full mx-4" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-4 border-b">
            <h5 class="text-lg font-semibold">QR Code</h5>
            <button (click)="closeQRModal()" class="text-2xl leading-none hover:text-gray-600">&times;</button>
        </div>
        <div class="p-4 text-center">
            <div id="qrCanvasModal">
                <!-- <div class="text-white text-xs mb-2">
                    Debug: qrCodeData = "{{ qrCodeData }}" ({{ qrCodeData ? 'HAS DATA' : 'EMPTY' }})
                </div> -->

                <!-- QR Code Image - Direct binding -->
                <div *ngIf="qrCodeData" class="inline-block relative">
                    <img [src]="getQRCodeUrl()" alt="QR Code"
                        class="w-72 h-72 mx-auto rounded-lg shadow-lg bg-white p-2" (error)="onQRImageError($event)"
                        (load)="onQRImageLoad()">

                    <!-- Logo Overlay -->
                    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white">
                        <img src="https://photobooth.awh.co.id/assets/photobooth/images/logo/logo_visidea_portrait_color.png"
                            alt="Visidea Logo" class="w-14 h-7 object-contain">
                    </div>
                </div>
                <div *ngIf="!qrCodeData" class="text-white text-sm">
                    Loading QR Code...
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Photo Preview Modal -->
<div *ngIf="showPhotoModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/90"
    (click)="closePhotoModal()">
    <div class="w-full max-w-6xl mx-4" (click)="$event.stopPropagation()">
        <div class="bg-cover bg-center rounded-lg"
            style="background-image: url('assets/photobooth/images/background-hasil.jpg')">
            <div class="flex justify-end p-4">
                <button (click)="closePhotoModal()"
                    class="text-white text-3xl leading-none hover:text-gray-300">&times;</button>
            </div>

            <div class="p-0">
                <div class="swiper photoPreviewSwiper">
                    <div class="swiper-wrapper" id="photoPreviewWrapper">
                        <!-- Photos will be dynamically added here -->
                    </div>
                    <div class="swiper-button-next text-white"></div>
                    <div class="swiper-button-prev text-white"></div>
                </div>
            </div>

            <div class="flex justify-center p-4 border-t-0">
                <button (click)="downloadCurrentPhoto()"
                    class="px-6 py-2 bg-[#F498AE] text-white rounded-lg hover:bg-[#e38899] transition">
                    Download Foto
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Review Rating Modal -->
<div *ngIf="showReviewModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    (click)="closeReviewModal()">
    <div class="bg-white rounded-lg max-w-md w-full mx-4" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-4 border-b">
            <h5 class="text-2xl font-bold text-center flex-1">Beri Ulasan Anda</h5>
            <button (click)="closeReviewModal()" class="text-2xl leading-none hover:text-gray-600">&times;</button>
        </div>

        <div class="p-4">
            <form>
                <div class="mb-4">
                    <label class="block text-2xl font-bold mb-2 text-center">Rating Photobooth Kami:</label>
                    <div class="flex justify-center text-5xl cursor-pointer gap-2">
                        <span *ngFor="let star of [1,2,3,4,5]" (click)="selectRating(star)"
                            [class.text-yellow-500]="star <= selectedRating"
                            [class.text-gray-400]="star > selectedRating" class="transition-colors">
                            &#9733;
                        </span>
                    </div>
                </div>

                <div class="mb-4">
                    <label for="reviewNote" class="block text-xl mb-2 text-center">Tinggalkan Catatan:</label>
                    <textarea [(ngModel)]="reviewNote" name="reviewNote" id="reviewNote" rows="3"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F498AE]"></textarea>
                </div>
            </form>
        </div>

        <div class="flex justify-end gap-2 p-4 border-t">
            <button (click)="closeReviewModal()"
                class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition">
                Tutup
            </button>
            <button (click)="submitReview()"
                class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition">
                Submit
            </button>
        </div>
    </div>
</div>

<!-- Thank You Modal -->
<div *ngIf="showThankYouModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    (click)="closeThankYouModal()">
    <div class="bg-white rounded-lg max-w-md w-full mx-4" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-4 border-b">
            <h5 class="text-lg font-semibold">Terima Kasih!</h5>
            <button (click)="closeThankYouModal()" class="text-2xl leading-none hover:text-gray-600">&times;</button>
        </div>

        <div class="p-4">
            <p>Review Anda telah berhasil dikirim. Terima kasih atas feedback Anda!</p>
        </div>

        <div class="flex justify-end p-4 border-t">
            <button (click)="closeThankYouModal()"
                class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition">
                Tutup
            </button>
        </div>
    </div>
</div>